import React from "react";

const inputCls =
  "w-full rounded-md border px-3 py-2 text-base transition-colors focus:outline-none focus:border-[var(--brand-primary)] focus:ring-2 focus:ring-[color:var(--brand-primary)]/25";

/**
 * Shared phone input used in SellForm and TicketModal's inline sell form.
 * - Always required.
 * - Renders a small "(required)" asterisk label and consistent helper copy.
 */
export const PhoneField = ({
  id,
  value,
  onChange,
  testId,
  placeholder = "(555) 555-5555",
  label = "Buyer phone",
  helper = "Required. If the buyer doesn't share, use your own number.",
  showLabel = true,
}) => {
  return (
    <div>
      {showLabel && (
        <label htmlFor={id} className="text-sm font-medium mb-1.5 block" style={{ color: "var(--ink-primary)" }}>
          {label} <span style={{ color: "var(--semantic-danger)" }}>*</span>
        </label>
      )}
      <input
        id={id}
        type="tel"
        required
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={testId}
        className={inputCls}
        style={{
          background: "var(--surface-card)",
          borderColor: "var(--border-default)",
          color: "var(--ink-primary)",
        }}
      />
      {helper && (
        <p className="text-xs mt-1.5" style={{ color: "var(--ink-tertiary)" }}>{helper}</p>
      )}
    </div>
  );
};

export const validatePhone = (value) => {
  if (!value || !value.trim()) {
    return "Buyer phone is required. Use your own number if the buyer doesn't share theirs.";
  }
  return null;
};
